export default __webpack_public_path__ + "static/media/site-bottom.1497c7ca.png";